import angular from 'angular'

let configModule = angular.module('app.config', [])
.constant('AppConfig', {
  'default': {
    'type': 'standalone',
    'endpoint': 'https://rcs-store-api.renault.worldline-solutions.com/api',
    'country': 'ch',
    'locales': [
      'ar',
      'bg',
      'cs',
      'da',
      'de',
      'el',
      'en',
      'es',
      'et',
      'fi',
      'fr',
      'hr',
      'hu',
      'it',
      'lt',
      'lv',
      'nl',
      'pl',
      'pt',
      'ro',
      'ru',
      'sk',
      'sl',
      'sv',
      'tr',
      'uk'
    ],
    'useCache': true,
    'guide': 'http://www.e-guide.renault.com',
    'rlinkModels': [
      {
        'id': 'model1Landscape',
        'title': 'rlink',
        'huType': 'MM12',
        'toolbox': {
          'windowsUrl': 'https://cdn.sa.services.tomtom.com/static/rltb/Windows/InstallRLinkToolbox.exe',
          'osxUrl': 'https://cdn.sa.services.tomtom.com/static/rltb/Mac/RLinkToolbox.dmg',
          'imageUrl': 'img/toolbox.jpg',
          'titleKey': 'registration.toolboxForm.fields.download.rlink.title',
          'descriptionKey': 'registration.toolboxForm.fields.download.rlink.description'
        },
        'type': 'landscape'
      },
      {
        'id': 'model2Portrait',
        'title': 'rlink2',
        'huType': 'RADNAV',
        'toolbox': {
          'windowsUrl': 'https://rcs-rlmanager.dcs2.renault.com/archives/win/RLink2Toolbox-latest.exe',
          'osxUrl': 'https://rcs-rlmanager.dcs2.renault.com/archives/mac/RLink2Toolbox-latest.dmg',
          'imageUrl': 'img/toolbox_2.jpg',
          'titleKey': 'registration.toolboxForm.fields.download.rlink2.title',
          'descriptionKey': 'registration.toolboxForm.fields.download.rlink2.description'
        },
        'type': 'portrait'
      },
      {
        'id': 'model2Landscape',
        'title': 'rlink2',
        'huType': 'RADNAV',
        'toolbox': {
          'windowsUrl': 'https://rcs-rlmanager.dcs2.renault.com/archives/win/RLink2Toolbox-latest.exe',
          'osxUrl': 'https://rcs-rlmanager.dcs2.renault.com/archives/mac/RLink2Toolbox-latest.dmg',
          'imageUrl': 'img/toolbox_2.jpg',
          'titleKey': 'registration.toolboxForm.fields.download.rlink2.title',
          'descriptionKey': 'registration.toolboxForm.fields.download.rlink2.description'
        },
        'type': 'landscape'
      }
    ],
    'googleRecaptchaClientKey': '6LcMcBEUAAAAANcj-ngWfpWhORUdieg0P7eXtZi0',
    'freeProductsOnly': false,
    'currency': 'EUR',
    'passwordExpirationDay': 1080
  },
  'fr': {
    'type': 'helios',
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-66069168-38',
    'errorUrl': 'https://www.renault.fr/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.fr',
    'gdprLink': 'https://easyconnect.renault.fr/pages/privacy'
  },
  'be': {
    'locales': [
      'fr',
      'nl'
    ],
    'trackingIdGA': 'UA-66069168-1',
    'gdprLink': 'https://easyconnect.renault.be/pages/privacy'
  },
  'lu': {
    'locales': [
      'fr',
      'en'
    ],
    'trackingIdGA': 'UA-66069168-2',
    'gdprLink': 'https://easyconnect.renault.lu/pages/privacy'
  },
  're': {
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-66069168-3',
    'gdprLink': 'https://easyconnect.renault.fr/pages/privacy'
  },
  'mq': {
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-66069168-4'
  },
  'yt': {
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-66069168-5'
  },
  'gp': {
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-66069168-6'
  },
  'gf': {
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-66069168-7'
  },
  'ch': {
    'locales': [
      'fr',
      'de',
      'it'
    ],
    'trackingIdGA': 'UA-66069168-42'
  },
  'at': {
    'locales': [
      'de'
    ],
    'trackingIdGA': 'UA-66069168-43',
    'gdprLink': 'https://easyconnect.renault.at/pages/privacy'
  },
  'ar': {
    'locales': [
      'en',
      'es'
    ],
    'trackingIdGA': 'UA-66069168-18'
  },
  'br': {
    'locales': [
      'en',
      'pb'
    ],
    'trackingIdGA': 'UA-66069168-21'
  },
  'cl': {
    'locales': [
      'en',
      'es'
    ],
    'trackingIdGA': 'UA-66069168-20',
    'freeProductsOnly': true
  },
  'mx': {
    'locales': [
      'en',
      'es'
    ],
    'trackingIdGA': 'UA-66069168-19'
  },
  'ee': {
    'locales': [
      'en',
      'et'
    ],
    'trackingIdGA': 'UA-66069168-26'
  },
  'lt': {
    'locales': [
      'en',
      'lt'
    ],
    'trackingIdGA': 'UA-66069168-24'
  },
  'lv': {
    'locales': [
      'en',
      'lv'
    ],
    'trackingIdGA': 'UA-66069168-23'
  },
  'gr': {
    'locales': [
      'en',
      'el'
    ],
    'trackingIdGA': 'UA-66069168-25'
  },
  'bg': {
    'locales': [
      'en',
      'bg'
    ],
    'trackingIdGA': 'UA-66073389-2'
  },
  'ua': {
    'locales': [
      'en',
      'uk'
    ],
    'trackingIdGA': 'UA-66069168-22'
  },
  'co': {
    'locales': [
      'en',
      'es'
    ],
    'trackingIdGA': 'UA-66073389-1'
  },
  'hu': {
    'locales': [
      'hu'
    ],
    'trackingIdGA': 'UA-66069168-34',
    'gdprLink': 'https://easyconnect.renault.hu/pages/privacy'
  },
  'cz': {
    'locales': [
      'cs'
    ],
    'trackingIdGA': 'UA-66069168-33',
    'gdprLink': 'https://easyconnect.renault.cz/pages/privacy'
  },
  'sk': {
    'locales': [
      'sk'
    ],
    'trackingIdGA': 'UA-66069168-35',
    'gdprLink': 'https://easyconnect.renault.co.uk/pages/privacy'
  },
  'de': {
    'type': 'helios',
    'locales': [
      'de'
    ],
    'trackingIdGA': 'UA-66069168-39',
    'errorUrl': 'https://www.renault.de/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.de',
    'gdprLink': 'https://easyconnect.renault.de/pages/privacy'
  },
  'es': {
    'type': 'helios',
    'locales': [
      'es'
    ],
    'trackingIdGA': 'UA-66069168-40',
    'errorUrl': 'https://www.renault.es/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.es',
    'gdprLink': 'https://easyconnect.renault.es/pages/privacy'
  },
  'ae': {
    'locales': [
      'en',
      'ar'
    ],
    'trackingIdGA': 'UA-66069168-27'
  },
  'bh': {
    'locales': [
      'en',
      'ar'
    ],
    'trackingIdGA': 'UA-66069168-28'
  },
  'kw': {
    'locales': [
      'en',
      'ar'
    ],
    'trackingIdGA': 'UA-66069168-29'
  },
  'om': {
    'locales': [
      'en',
      'ar'
    ],
    'trackingIdGA': 'UA-66069168-30'
  },
  'qa': {
    'locales': [
      'en',
      'ar'
    ],
    'trackingIdGA': 'UA-66069168-31'
  },
  'sa': {
    'locales': [
      'en',
      'ar'
    ],
    'trackingIdGA': 'UA-66069168-32'
  },
  'it': {
    'type': 'helios',
    'locales': [
      'it'
    ],
    'trackingIdGA': 'UA-66069168-41',
    'errorUrl': 'https://www.renault.it/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.it'
  },
  'ma': {
    'type': 'helios',
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-66069168-36',
    'errorUrl': 'https://www.renault.ma/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.ma'
  },
  'dz': {
    'type': 'helios',
    'locales': [
      'fr'
    ],
    'trackingIdGA': 'UA-66069168-37',
    'errorUrl': 'https://www.renault.dz/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.dz'
  },
  'gb': {
    'locales': [
      'en'
    ],
    'trackingIdGA': 'UA-66069168-8',
    'currency': 'GBP',
    'gdprLink': 'https://easyconnect.renault.co.uk/pages/privacy'
  },
  'ie': {
    'locales': [
      'en'
    ],
    'trackingIdGA': 'UA-66069168-9',
    'gdprLink': 'https://easyconnect.renault.co.ie/pages/privacy'
  },
  'in': {
    'locales': [
      'en'
    ],
    'trackingIdGA': 'UA-66069168-11'
  },
  'au': {
    'locales': [
      'en'
    ],
    'trackingIdGA': 'UA-66069168-10'
  },
  'za': {
    'locales': [
      'en'
    ],
    'trackingIdGA': 'UA-66069168-12'
  },
  'se': {
    'locales': [
      'sv'
    ],
    'trackingIdGA': 'UA-66069168-13',
    'gdprLink': 'https://easyconnect.renault.se/pages/privacy'
  },
  'no': {
    'locales': [
      'no'
    ],
    'trackingIdGA': 'UA-66069168-14'
  },
  'fi': {
    'locales': [
      'en',
      'fi',
      'sv'
    ],
    'trackingIdGA': 'UA-66069168-16',
    'gdprLink': 'https://easyconnect.renault.co.uk/pages/privacy'
  },
  'dk': {
    'locales': [
      'da'
    ],
    'trackingIdGA': 'UA-66069168-15',
    'gdprLink': 'https://easyconnect.renault.dk/pages/privacy'
  },
  'si': {
    'type': 'helios',
    'locales': [
      'sl'
    ],
    'trackingIdGA': 'UA-66069168-45',
    'errorUrl': 'https://www.renault.si/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.si',
    'gdprLink': 'https://easyconnect.renault.co.uk/pages/privacy'
  },
  'hr': {
    'type': 'helios',
    'locales': [
      'hr'
    ],
    'trackingIdGA': 'UA-66069168-44',
    'errorUrl': 'https://www.renault.hr/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.hr',
    'gdprLink': 'https://easyconnect.renault.hr/pages/privacy'
  },
  'nl': {
    'locales': [
      'nl'
    ],
    'trackingIdGA': 'UA-66069168-46',
    'gdprLink': 'https://easyconnect.renault.nl/pages/privacy'
  },
  'pl': {
    'type': 'helios',
    'locales': [
      'pl'
    ],
    'trackingIdGA': 'UA-66069168-47',
    'errorUrl': 'https://www.renault.pl/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.pl',
    'gdprLink': 'https://easyconnect.renault.pl/pages/privacy'
  },
  'pt': {
    'type': 'helios',
    'locales': [
      'pt'
    ],
    'trackingIdGA': 'UA-66069168-48',
    'errorUrl': 'https://www.renault.pt/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.pt',
    'gdprLink': 'https://easyconnect.renault.pt/pages/privacy'
  },
  'ro': {
    'type': 'helios',
    'locales': [
      'ro'
    ],
    'trackingIdGA': 'UA-66069168-49',
    'errorUrl': 'https://www.renault.ro/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.ro',
    'gdprLink': 'https://easyconnect.renault.at/pages/privacy'
  },
  'ru': {
    'type': 'helios',
    'locales': [
      'ru',
      'en'
    ],
    'trackingIdGA': 'UA-66069168-50',
    'currency': 'RUB',
    'errorUrl': 'https://www.renault.ru/esc/rlink/store/error.action?error=',
    'rootUrl': 'https://myr.renault.ru'
  },
  'tr': {
    'locales': [
      'tr'
    ],
    'trackingIdGA': 'UA-66069168-17'
  },
  'zz': {
    'locales': [
      'fr',
      'en'
    ],
    'trackingIdGA': 'UA-xxxxxxxx-xx'
  },
  'pages': {
    'home': {
      'slides': [
        'photo_001',
        'photo_002',
        'photo_003',
        'photo_004',
        'photo_005',
        'photo_006'
      ],
      'paragraphs': [
        'illustration_01',
        'illustration_02'
      ]
    }
  }
})
.name

export default configModule



// WEBPACK FOOTER //
// ./src-generated/app.config.js